export default "__VITE_ASSET__31eded14__"